export default {"src":"/_next/static/media/usa-flag.8a2c38af.svg","height":650,"width":1235,"blurWidth":0,"blurHeight":0};